import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                prev: 'prev',
                next: 'next'
            }
        }
    }

    init() {

        // this.$controls = this.$('controls')[0];

        this.swiper = new Swiper(this.$('slideshow')[0], {
            // direction: 'horizontal',
            effect: 'fade',
            autoHeight: true,
            speed: 900,
            allowTouchMove: true,
            pagination: {
                el: this.$('pagination'),
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                1000: {
                    // direction: 'vertical',
                    // allowTouchMove: false,
                }
            },
            on: {
                slideChangeTransitionEnd: (swiper) => {
                    this.call('update', null, 'scrollTo')
                }
            }
        });

    }

    prev() {
        this.swiper.slidePrev();
    }

    next() {
        this.swiper.slideNext();
    }
}
